module.exports = __webpack_public_path__ + "img/sala-2.895b45f2.jpg";